var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app page-login flex-row align-items-center" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group mb-3" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username",
                        },
                      ],
                      staticClass: "form-control login",
                      attrs: {
                        type: "text",
                        required: "",
                        placeholder: "Username",
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.username = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group mb-4" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-control login",
                      attrs: {
                        type: "password",
                        required: "",
                        placeholder: "Password",
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.password = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary px-4 login",
                      attrs: { type: "submit" },
                    },
                    [_vm._v("\n            Login\n          ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row center-block" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link forgotP",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.myModal = true
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "fogotP" }, [
                          _vm._v(
                            "\n                Forgotten your password?\n              "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.errLogin
                    ? _c("div", { staticClass: "text-red loginError" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("span", { staticClass: "errLogin" }, [
                          _vm._v(_vm._s(_vm.errLogin)),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.myModal
                ? _c(
                    "b-modal",
                    {
                      staticClass: "aligned",
                      attrs: { title: "Reset Password", "hide-footer": "" },
                      on: {
                        ok: function ($event) {
                          _vm.myModal = false
                        },
                      },
                      model: {
                        value: _vm.myModal,
                        callback: function ($$v) {
                          _vm.myModal = $$v
                        },
                        expression: "myModal",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Forgot your password? No problem. Just enter your email below and we'll send a you a link to reset it.\n          "
                      ),
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.resetPassword.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "resetModal" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.username,
                                  expression: "username",
                                },
                              ],
                              staticClass: "form-control login",
                              attrs: {
                                type: "text",
                                required: "",
                                placeholder: "Email Address",
                              },
                              domProps: { value: _vm.username },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.username = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary login center-block modalSubmit",
                              attrs: { type: "submit" },
                            },
                            [_vm._v("\n              Submit\n            ")]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(2),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "opening-message" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: "static/img/leakcentral_horizontal.svg",
          alt: "Leak Central logo",
        },
      }),
      _vm._v(" "),
      _c("p", [_vm._v("To login, enter your username and password.")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "You will also need your authenticator app to enter a security passcode."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "errorImg" }, [
      _c("img", { attrs: { src: "static/img/error.svg", alt: "login error" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "login-footer" }, [
      _c("img", {
        staticClass: "labs-logo center-block",
        attrs: { src: "static/img/labs_logo.svg", alt: "labs-img" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }